<template>
    <v-col>
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn">
                <h1>{{ $t("tours_types.new_tours_types") }}</h1>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_tours_types">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("tours_types.tours_infos") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="designation"
                                    :label="$t('tours_types.designation')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-menu
                                    v-model="menu_date_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="auto"
                                    offset-y
                                    transition="scale-transition"
                                >
                                    <template #activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateRangeText"
                                            :label="$t('tours_types.dates')"
                                            append-icon="mdi-calendar-range"
                                            dense
                                            hide-details="auto"
                                            light
                                            outlined
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="selected_dates"
                                        range
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <div class="checkbox-line">
                                    <v-checkbox
                                        v-model="is_monday"
                                        :label="$t('tours_types.monday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="is_tuesday"
                                        :label="$t('tours_types.tuesday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="is_wednesday"
                                        :label="$t('tours_types.wednesday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="is_thursday"
                                        :label="$t('tours_types.thursday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="is_friday"
                                        :label="$t('tours_types.friday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="is_saturday"
                                        :label="$t('tours_types.saturday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="is_sunday"
                                        :label="$t('tours_types.sunday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <v-btn color="primary" :loading="loading" elevation="0" @click="create">
                    {{ $t("global.save") }}
                </v-btn>
            </v-form>
        </div>
    </v-col>
</template>

<script>
export default {
    name: "NewToursTypes",

    data() {
        return {
            designation: null,
            selected_dates: null,
            menu_date_picker: false,
            is_monday: false,
            is_tuesday: false,
            is_wednesday: false,
            is_thursday: false,
            is_friday: false,
            is_saturday: false,
            is_sunday: false,
            loading: false,
        };
    },
    computed: {
        dateRangeText() {
            if (!this.selected_dates)
                return ""

            return this.selected_dates
                .map(date => date.toDate()).sort().join(' ~ ')
        },
    },

    methods: {
        async create() {
            this.loading = true
            try {
                await this.$api.tour_types.create({
                    designation: this.designation,
                    ...(this.selected_dates !== null && {start_date: this.selected_dates[0]}),
                    ...(this.selected_dates !== null && {end_date: this.selected_dates[1]}),
                    is_monday: this.is_monday,
                    is_tuesday: this.is_tuesday,
                    is_wednesday: this.is_wednesday,
                    is_thursday: this.is_thursday,
                    is_friday: this.is_friday,
                    is_saturday: this.is_saturday,
                    is_sunday: this.is_sunday,
                }).then(() => this.$router.push({name: 'tours_types'}))
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        }
    }
};
</script>
